import type { FullReportResponse } from '../../lib/apiClient';
import { BottleneckReport } from './BottleneckReport';
import { WorkFitReport } from './WorkFitReport';
import { PerspectiveReport } from './PerspectiveReport';

/** Dispatch a full-report payload to the correct per-type renderer. */
export function ReportBody({
  data,
  firstName = null,
}: {
  data: FullReportResponse;
  /** Production personalises the Bottleneck hero when it knows the name. */
  firstName?: string | null;
}) {
  const { result, report } = data;
  if (report.assessmentType === 'bottleneck') {
    return (
      <BottleneckReport
        result={result}
        content={report.content}
        firstName={firstName}
        previousResult={data.previousResult ?? null}
      />
    );
  }
  if (report.assessmentType === 'work_fit') {
    return (
      <WorkFitReport
        result={result}
        content={report.content}
        environmentNeeds={report.environmentNeeds}
        misfitSignals={report.misfitSignals}
      />
    );
  }
  return (
    <PerspectiveReport
      result={result}
      content={report.content}
      interpretationTraps={report.interpretationTraps}
      sevenDayReset={report.sevenDayReset}
      thirtyDayPractice={report.thirtyDayPractice}
      disclaimer={report.disclaimer}
    />
  );
}
